import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import PricingTableRow from './PricingTableRow';

interface Props {
  items: {
    id: string;
    name: string;
    price: number;
    quantity: number;
    onPriceChange: (value: number) => void;
    onQuantityChange?: (value: number) => void;
    onRemove?: () => void;
    disabled?: boolean;
  }[];
}

function CheckoutFormItems({ items }: Props) {
  const theme = useTheme();
  return (
    <Box className="input-group">
      <Typography variant="h2">Transaction Details</Typography>
      <Box className="transaction-items-table" width="100%" overflow="auto">
        <Table style={{ width: '100%' }}>
          <TableHead>
            <TableRow
              sx={{
                borderBottom: `1px solid ${theme.palette.darkGrey.main}`,
              }}>
              <TableCell
                component="th"
                scope="header"
                sx={{
                  padding: 0,
                  border: 0,
                }}>
                <Typography variant="h4">Item</Typography>
              </TableCell>
              <TableCell
                component="th"
                scope="header"
                sx={{
                  paddingY: 0,
                  border: 0,
                }}>
                <Typography variant="h4">Qty.</Typography>
              </TableCell>
              <TableCell
                component="th"
                scope="header"
                sx={{
                  paddingY: 0,
                  border: 0,
                }}>
                <Typography variant="h4">Price</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <PricingTableRow
                key={item.id}
                checkoutItem={{
                  id: item.id,
                  name: item.name,
                  price: item.price,
                  quantity: item.quantity,
                }}
                onPriceChange={item.onPriceChange}
                onQuantityChange={item.onQuantityChange}
                onRemove={item.onRemove}
                disabled={item.disabled}
                isQuantityDisabled={!item.onQuantityChange}
              />
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
}

export default CheckoutFormItems;
